/* This file was generated automatically. Do not edit manually. */

import { createAccountChargeablePreauthorizationsRepository as accountChargeablePreauthorizations } from './accountChargeablePreauthorizations';
import { createAccountFilesRepository as accountFiles } from './accountFiles';
import { createAccountNotesRepository as accountNotes } from './accountNotes';
import { createAccountPaymentMethodsRepository as accountPaymentMethods } from './accountPaymentMethods';
import { createAccountPaymentRequestsRepository as accountPaymentRequests } from './accountPaymentRequests';
import { createAccountingRepository as accounting } from './accounting';
import { createAccountingCategoriesRepository as accountingCategories } from './accountingCategories';
import { createAccountingConfigurationsRepository as accountingConfigurations } from './accountingConfigurations';
import { createAccountsRepository as accounts } from './accounts';
import { createActionLogItemsRepository as actionLogItems } from './actionLogItems';
import { createAddressesRepository as addresses } from './addresses';
import { createAdyenPaymentTerminalIntegrationRepository as adyenPaymentTerminalIntegration } from './adyenPaymentTerminalIntegration';
import { createAllowancesRepository as allowances } from './allowances';
import { createAlternativePaymentMethodIntegrationRepository as alternativePaymentMethodIntegration } from './alternativePaymentMethodIntegration';
import { createAnalyticsIntegrationRepository as analyticsIntegration } from './analyticsIntegration';
import { createAndorraPoliceExportIntegrationRepository as andorraPoliceExportIntegration } from './andorraPoliceExportIntegration';
import { createAvailabilityBlockCountersRepository as availabilityBlockCounters } from './availabilityBlockCounters';
import { createAvailabilityBlockReportRepository as availabilityBlockReport } from './availabilityBlockReport';
import { createAvailabilityBlocksRepository as availabilityBlocks } from './availabilityBlocks';
import { createAvailabilityReportRepository as availabilityReport } from './availabilityReport';
import { createAvsBaselExportIntegrationRepository as avsBaselExportIntegration } from './avsBaselExportIntegration';
import { createBaselPoliceExportIntegrationRepository as baselPoliceExportIntegration } from './baselPoliceExportIntegration';
import { createBillCountersRepository as billCounters } from './billCounters';
import { createBillItemsRepository as billItems } from './billItems';
import { createBillPreviewCountersRepository as billPreviewCounters } from './billPreviewCounters';
import { createBillingRepository as billing } from './billing';
import { createBillingScreenRepository as billingScreen } from './billingScreen';
import { createBillsRepository as bills } from './bills';
import { createBookingEnginesRepository as bookingEngines } from './bookingEngines';
import { createBusinessSegmentsRepository as businessSegments } from './businessSegments';
import { createCalendarEventsRepository as calendarEvents } from './calendarEvents';
import { createCancellationPoliciesRepository as cancellationPolicies } from './cancellationPolicies';
import { createCashPaymentsRepository as cashPayments } from './cashPayments';
import { createCashierAssignmentsRepository as cashierAssignments } from './cashierAssignments';
import { createCashiersRepository as cashiers } from './cashiers';
import { createCataloniaAccommodationExportIntegrationRepository as cataloniaAccommodationExportIntegration } from './cataloniaAccommodationExportIntegration';
import { createCataloniaPoliceExportIntegrationRepository as cataloniaPoliceExportIntegration } from './cataloniaPoliceExportIntegration';
import { createChainsRepository as chains } from './chains';
import { createChannelManagerAgeCategoryRepository as channelManagerAgeCategory } from './channelManagerAgeCategory';
import { createChargeablePreauthorizationsRepository as chargeablePreauthorizations } from './chargeablePreauthorizations';
import { createCheckInConfigurationsRepository as checkInConfigurations } from './checkInConfigurations';
import { createCitiesRepository as cities } from './cities';
import { createCityLedgerRepository as cityLedger } from './cityLedger';
import { createCompaniesRepository as companies } from './companies';
import { createCompanionshipsRepository as companionships } from './companionships';
import { createConnectorIntegrationRepository as connectorIntegration } from './connectorIntegration';
import { createCorrectionBillCountersRepository as correctionBillCounters } from './correctionBillCounters';
import { createCorrectionsRepository as corrections } from './corrections';
import { createCountersRepository as counters } from './counters';
import { createCreditCardPaymentsRepository as creditCardPayments } from './creditCardPayments';
import { createCreditCardsRepository as creditCards } from './creditCards';
import { createCreditLimitsRepository as creditLimits } from './creditLimits';
import { createCreditNoteBillCountersRepository as creditNoteBillCounters } from './creditNoteBillCounters';
import { createCulturesRepository as cultures } from './cultures';
import { createCurrencyAcceptancesRepository as currencyAcceptances } from './currencyAcceptances';
import { createCustomersRepository as customers } from './customers';
import { createCzechPoliceExportIntegrationRepository as czechPoliceExportIntegration } from './czechPoliceExportIntegration';
import { createDepartmentsRepository as departments } from './departments';
import { createDepositledgerRepository as depositledger } from './depositledger';
import { createDeviceAuthorizationRepository as deviceAuthorization } from './deviceAuthorization';
import { createDevicesRepository as devices } from './devices';
import { createDigitalKeyConfigurationRepository as digitalKeyConfiguration } from './digitalKeyConfiguration';
import { createEmailDomainsRepository as emailDomains } from './emailDomains';
import { createEmailWhitelistConfigurationsRepository as emailWhitelistConfigurations } from './emailWhitelistConfigurations';
import { createEnterpriseBuilderRepository as enterpriseBuilder } from './enterpriseBuilder';
import { createEnterpriseProfileRolesRepository as enterpriseProfileRoles } from './enterpriseProfileRoles';
import { createEnterpriseProfilesRepository as enterpriseProfiles } from './enterpriseProfiles';
import { createEnterpriseRelationshipsRepository as enterpriseRelationships } from './enterpriseRelationships';
import { createEnterprisesRepository as enterprises } from './enterprises';
import { createEntityMappingsRepository as entityMappings } from './entityMappings';
import { createEuskalHerriaAccommodationExportIntegrationRepository as euskalHerriaAccommodationExportIntegration } from './euskalHerriaAccommodationExportIntegration';
import { createEuskalHerriaPoliceExportIntegrationRepository as euskalHerriaPoliceExportIntegration } from './euskalHerriaPoliceExportIntegration';
import { createExcelProcessingRepository as excelProcessing } from './excelProcessing';
import { createExportScheduleRepository as exportSchedule } from './exportSchedule';
import { createExportTargetsRepository as exportTargets } from './exportTargets';
import { createExportsRepository as exports } from './exports';
import { createExternalPaymentFormRepository as externalPaymentForm } from './externalPaymentForm';
import { createExternalPaymentsRepository as externalPayments } from './externalPayments';
import { createFinancialDocumentsRepository as financialDocuments } from './financialDocuments';
import { createGatewayCardPaymentsRepository as gatewayCardPayments } from './gatewayCardPayments';
import { createGatewayPaymentsRepository as gatewayPayments } from './gatewayPayments';
import { createGatewayPreauthorizationsRepository as gatewayPreauthorizations } from './gatewayPreauthorizations';
import { createGeneralConfigurationRepository as generalConfiguration } from './generalConfiguration';
import { createGlobalizationRepository as globalization } from './globalization';
import { createGoodDataRepository as goodData } from './goodData';
import { createGuestInHouseRepository as guestInHouse } from './guestInHouse';
import { createGuestLedgerRepository as guestLedger } from './guestLedger';
import { createIdentityDocumentsRepository as identityDocuments } from './identityDocuments';
import { createImportsRepository as imports } from './imports';
import { createInstantPayoutRepository as instantPayout } from './instantPayout';
import { createIntegrationClientDataRepository as integrationClientData } from './integrationClientData';
import { createIntegrationDataRepository as integrationData } from './integrationData';
import { createIntegrationsRepository as integrations } from './integrations';
import { createInvoicesRepository as invoices } from './invoices';
import { createIstatAbruzzoExportIntegrationRepository as istatAbruzzoExportIntegration } from './istatAbruzzoExportIntegration';
import { createIstatCalabriaExportIntegrationRepository as istatCalabriaExportIntegration } from './istatCalabriaExportIntegration';
import { createIstatSardiniaExportIntegrationRepository as istatSardiniaExportIntegration } from './istatSardiniaExportIntegration';
import { createJobsRepository as jobs } from './jobs';
import { createKeyCutterIntegrationRepository as keyCutterIntegration } from './keyCutterIntegration';
import { createKeyCuttersRepository as keyCutters } from './keyCutters';
import { createLanguagesRepository as languages } from './languages';
import { createLocalizationRepository as localization } from './localization';
import { createLookupRepository as lookup } from './lookup';
import { createLoyaltyRepository as loyalty } from './loyalty';
import { createLoyaltyMembershipsRepository as loyaltyMemberships } from './loyaltyMemberships';
import { createLoyaltyProgramsRepository as loyaltyPrograms } from './loyaltyPrograms';
import { createMailTemplatesRepository as mailTemplates } from './mailTemplates';
import { createMerchantIntegrationRepository as merchantIntegration } from './merchantIntegration';
import { createMessageThreadsRepository as messageThreads } from './messageThreads';
import { createMessagesRepository as messages } from './messages';
import { createMewsBIRepository as mewsBI } from './mewsBI';
import { createMewsBiIntegrationRepository as mewsBiIntegration } from './mewsBiIntegration';
import { createMfaConfigurationRepository as mfaConfiguration } from './mfaConfiguration';
import { createMultiCurrencyServiceConfigurationRepository as multiCurrencyServiceConfiguration } from './multiCurrencyServiceConfiguration';
import { createNonGatewayCardPaymentsRepository as nonGatewayCardPayments } from './nonGatewayCardPayments';
import { createNonGatewayPreauthorizationsRepository as nonGatewayPreauthorizations } from './nonGatewayPreauthorizations';
import { createNotificationsRepository as notifications } from './notifications';
import { createOakyRepository as oaky } from './oaky';
import { createOpenPayoutTransactionsRepository as openPayoutTransactions } from './openPayoutTransactions';
import { createOpenPayoutsRepository as openPayouts } from './openPayouts';
import { createOrderItemsRepository as orderItems } from './orderItems';
import { createOutletsRepository as outlets } from './outlets';
import { createPassportScanIntegrationRepository as passportScanIntegration } from './passportScanIntegration';
import { createPassportScannerIntegrationRepository as passportScannerIntegration } from './passportScannerIntegration';
import { createPassportScannerIntegrationsRepository as passportScannerIntegrations } from './passportScannerIntegrations';
import { createPassportScannersRepository as passportScanners } from './passportScanners';
import { createPaymentAndCancellationPoliciesRepository as paymentAndCancellationPolicies } from './paymentAndCancellationPolicies';
import { createPaymentCardRepository as paymentCard } from './paymentCard';
import { createPaymentCardAuthorizationRepository as paymentCardAuthorization } from './paymentCardAuthorization';
import { createPaymentCardsRepository as paymentCards } from './paymentCards';
import { createPaymentConfirmationBillCountersRepository as paymentConfirmationBillCounters } from './paymentConfirmationBillCounters';
import { createPaymentDetailsRepository as paymentDetails } from './paymentDetails';
import { createPaymentGatewaysRepository as paymentGateways } from './paymentGateways';
import { createPaymentMethodDetailsRepository as paymentMethodDetails } from './paymentMethodDetails';
import { createPaymentMethodsRepository as paymentMethods } from './paymentMethods';
import { createPaymentPlanCreateFormRepository as paymentPlanCreateForm } from './paymentPlanCreateForm';
import { createPaymentPlansRepository as paymentPlans } from './paymentPlans';
import { createPaymentRefundFormRepository as paymentRefundForm } from './paymentRefundForm';
import { createPaymentRequestsRepository as paymentRequests } from './paymentRequests';
import { createPaymentTerminalsRepository as paymentTerminals } from './paymentTerminals';
import { createPaymentsRepository as payments } from './payments';
import { createPayoutDetailRepository as payoutDetail } from './payoutDetail';
import { createPayoutDetailSummariesRepository as payoutDetailSummaries } from './payoutDetailSummaries';
import { createPayoutReportRepository as payoutReport } from './payoutReport';
import { createPayoutSummariesRepository as payoutSummaries } from './payoutSummaries';
import { createPayoutTransactionsRepository as payoutTransactions } from './payoutTransactions';
import { createPayoutsRepository as payouts } from './payouts';
import { createPlatformGlobalizationRepository as platformGlobalization } from './platformGlobalization';
import { createPlatformProfilesRepository as platformProfiles } from './platformProfiles';
import { createPreauthorizationRequestsRepository as preauthorizationRequests } from './preauthorizationRequests';
import { createPreauthorizationsRepository as preauthorizations } from './preauthorizations';
import { createPricingRepository as pricing } from './pricing';
import { createPrinterIntegrationRepository as printerIntegration } from './printerIntegration';
import { createPrintersRepository as printers } from './printers';
import { createProductCategoriesRepository as productCategories } from './productCategories';
import { createProductChecklistRepository as productChecklist } from './productChecklist';
import { createProductRulesRepository as productRules } from './productRules';
import { createProductServiceOrdersRepository as productServiceOrders } from './productServiceOrders';
import { createProductSubscriptionsRepository as productSubscriptions } from './productSubscriptions';
import { createProductsRepository as products } from './products';
import { createProformaCountersRepository as proformaCounters } from './proformaCounters';
import { createPromotedServiceAssignmentsRepository as promotedServiceAssignments } from './promotedServiceAssignments';
import { createRateGroupsRepository as rateGroups } from './rateGroups';
import { createRatesRepository as rates } from './rates';
import { createRegistrationCardCountersRepository as registrationCardCounters } from './registrationCardCounters';
import { createReportExporterRepository as reportExporter } from './reportExporter';
import { createReportTypesRepository as reportTypes } from './reportTypes';
import { createResDiaryRepository as resDiary } from './resDiary';
import { createResDiaryIntegrationRepository as resDiaryIntegration } from './resDiaryIntegration';
import { createReservationContractExternalTemplatesRepository as reservationContractExternalTemplates } from './reservationContractExternalTemplates';
import { createReservationContractTemplatesRepository as reservationContractTemplates } from './reservationContractTemplates';
import { createReservationContractsRepository as reservationContracts } from './reservationContracts';
import { createReservationGroupsRepository as reservationGroups } from './reservationGroups';
import { createReservationsRepository as reservations } from './reservations';
import { createResourceBlocksRepository as resourceBlocks } from './resourceBlocks';
import { createResourceCategoriesRepository as resourceCategories } from './resourceCategories';
import { createResourceUsesRepository as resourceUses } from './resourceUses';
import { createResourcesRepository as resources } from './resources';
import { createRestrictionsRepository as restrictions } from './restrictions';
import { createRolesRepository as roles } from './roles';
import { createRoutingRuleAssignmentsRepository as routingRuleAssignments } from './routingRuleAssignments';
import { createRoutingRulesRepository as routingRules } from './routingRules';
import { createSalesforceRepository as salesforce } from './salesforce';
import { createScimConfigurationRepository as scimConfiguration } from './scimConfiguration';
import { createSellLimitsRepository as sellLimits } from './sellLimits';
import { createSepaDirectDebitPaymentsRepository as sepaDirectDebitPayments } from './sepaDirectDebitPayments';
import { createServiceOrderCountersRepository as serviceOrderCounters } from './serviceOrderCounters';
import { createServiceOrdersRepository as serviceOrders } from './serviceOrders';
import { createServicesRepository as services } from './services';
import { createSettlementRulesRepository as settlementRules } from './settlementRules';
import { createSettlementsRepository as settlements } from './settlements';
import { createSmsIntegrationRepository as smsIntegration } from './smsIntegration';
import { createSmsUsaBrandRegistrationRepository as smsUsaBrandRegistration } from './smsUsaBrandRegistration';
import { createSsoConnectionRepository as ssoConnection } from './ssoConnection';
import { createSubscriptionsRepository as subscriptions } from './subscriptions';
import { createSupportedGatewayCardTypesRepository as supportedGatewayCardTypes } from './supportedGatewayCardTypes';
import { createTargetsRepository as targets } from './targets';
import { createTasksRepository as tasks } from './tasks';
import { createTerminalOrderRepository as terminalOrder } from './terminalOrder';
import { createTerminalRequestRepository as terminalRequest } from './terminalRequest';
import { createTextMessagingConfigurationRepository as textMessagingConfiguration } from './textMessagingConfiguration';
import { createTravelAgenciesRepository as travelAgencies } from './travelAgencies';
import { createTrialBalanceRepository as trialBalance } from './trialBalance';
import { createUserGroupsRepository as userGroups } from './userGroups';
import { createUserProfilesRepository as userProfiles } from './userProfiles';
import { createUsersRepository as users } from './users';
import { createVostioKeyCutterIntegrationRepository as vostioKeyCutterIntegration } from './vostioKeyCutterIntegration';
import { createVoucherCodesRepository as voucherCodes } from './voucherCodes';
import { createVoucherRedemptionRepository as voucherRedemption } from './voucherRedemption';
import { createVouchersRepository as vouchers } from './vouchers';

export * from './types';

export const commanderApiBasePath = '/api/commander/v1';

export const commanderRestRepositoryFactories = {
    accountChargeablePreauthorizations,
    accountFiles,
    accountNotes,
    accountPaymentMethods,
    accountPaymentRequests,
    accounting,
    accountingCategories,
    accountingConfigurations,
    accounts,
    actionLogItems,
    addresses,
    adyenPaymentTerminalIntegration,
    allowances,
    alternativePaymentMethodIntegration,
    analyticsIntegration,
    andorraPoliceExportIntegration,
    availabilityBlockCounters,
    availabilityBlockReport,
    availabilityBlocks,
    availabilityReport,
    avsBaselExportIntegration,
    baselPoliceExportIntegration,
    billCounters,
    billItems,
    billPreviewCounters,
    billing,
    billingScreen,
    bills,
    bookingEngines,
    businessSegments,
    calendarEvents,
    cancellationPolicies,
    cashPayments,
    cashierAssignments,
    cashiers,
    cataloniaAccommodationExportIntegration,
    cataloniaPoliceExportIntegration,
    chains,
    channelManagerAgeCategory,
    chargeablePreauthorizations,
    checkInConfigurations,
    cities,
    cityLedger,
    companies,
    companionships,
    connectorIntegration,
    correctionBillCounters,
    corrections,
    counters,
    creditCardPayments,
    creditCards,
    creditLimits,
    creditNoteBillCounters,
    cultures,
    currencyAcceptances,
    customers,
    czechPoliceExportIntegration,
    departments,
    depositledger,
    deviceAuthorization,
    devices,
    digitalKeyConfiguration,
    emailDomains,
    emailWhitelistConfigurations,
    enterpriseBuilder,
    enterpriseProfileRoles,
    enterpriseProfiles,
    enterpriseRelationships,
    enterprises,
    entityMappings,
    euskalHerriaAccommodationExportIntegration,
    euskalHerriaPoliceExportIntegration,
    excelProcessing,
    exportSchedule,
    exportTargets,
    exports,
    externalPaymentForm,
    externalPayments,
    financialDocuments,
    gatewayCardPayments,
    gatewayPayments,
    gatewayPreauthorizations,
    generalConfiguration,
    globalization,
    goodData,
    guestInHouse,
    guestLedger,
    identityDocuments,
    imports,
    instantPayout,
    integrationClientData,
    integrationData,
    integrations,
    invoices,
    istatAbruzzoExportIntegration,
    istatCalabriaExportIntegration,
    istatSardiniaExportIntegration,
    jobs,
    keyCutterIntegration,
    keyCutters,
    languages,
    localization,
    lookup,
    loyalty,
    loyaltyMemberships,
    loyaltyPrograms,
    mailTemplates,
    merchantIntegration,
    messageThreads,
    messages,
    mewsBI,
    mewsBiIntegration,
    mfaConfiguration,
    multiCurrencyServiceConfiguration,
    nonGatewayCardPayments,
    nonGatewayPreauthorizations,
    notifications,
    oaky,
    openPayoutTransactions,
    openPayouts,
    orderItems,
    outlets,
    passportScanIntegration,
    passportScannerIntegration,
    passportScannerIntegrations,
    passportScanners,
    paymentAndCancellationPolicies,
    paymentCard,
    paymentCardAuthorization,
    paymentCards,
    paymentConfirmationBillCounters,
    paymentDetails,
    paymentGateways,
    paymentMethodDetails,
    paymentMethods,
    paymentPlanCreateForm,
    paymentPlans,
    paymentRefundForm,
    paymentRequests,
    paymentTerminals,
    payments,
    payoutDetail,
    payoutDetailSummaries,
    payoutReport,
    payoutSummaries,
    payoutTransactions,
    payouts,
    platformGlobalization,
    platformProfiles,
    preauthorizationRequests,
    preauthorizations,
    pricing,
    printerIntegration,
    printers,
    productCategories,
    productChecklist,
    productRules,
    productServiceOrders,
    productSubscriptions,
    products,
    proformaCounters,
    promotedServiceAssignments,
    rateGroups,
    rates,
    registrationCardCounters,
    reportExporter,
    reportTypes,
    resDiary,
    resDiaryIntegration,
    reservationContractExternalTemplates,
    reservationContractTemplates,
    reservationContracts,
    reservationGroups,
    reservations,
    resourceBlocks,
    resourceCategories,
    resourceUses,
    resources,
    restrictions,
    roles,
    routingRuleAssignments,
    routingRules,
    salesforce,
    scimConfiguration,
    sellLimits,
    sepaDirectDebitPayments,
    serviceOrderCounters,
    serviceOrders,
    services,
    settlementRules,
    settlements,
    smsIntegration,
    smsUsaBrandRegistration,
    ssoConnection,
    subscriptions,
    supportedGatewayCardTypes,
    targets,
    tasks,
    terminalOrder,
    terminalRequest,
    textMessagingConfiguration,
    travelAgencies,
    trialBalance,
    userGroups,
    userProfiles,
    users,
    vostioKeyCutterIntegration,
    voucherCodes,
    voucherRedemption,
    vouchers,
};
